import USER_ROLES from "../../../../constants/userRoles.constants";

class UserProfileController {
    constructor(userService, $mdDialog, $mdToast) {
        let self = this;

        self.showUserProfile = () => {
            userService.getById(self.user.id).then(user => {
                $mdDialog.show({
                    clickOutsideToClose: true,
                    templateUrl: 'userProfileDialog.tmpl.html',
                    parent: angular.element(document.body),
                    multiple: true,
                    locals: {
                        user: user,
                        userService: userService
                    },
                    controller: function DialogController($scope, $mdDialog, user, userService) {
                        $scope.user = user;
                        $scope.isAdmin = user.roles.includes(USER_ROLES.ROLE_ADMIN);

                        $scope.saveUser = () => {
                            if(!$scope.userForm.$invalid) {
                                if (!$scope.user.roles.includes(USER_ROLES.ROLE_ADMIN) && $scope.isAdmin) {
                                    $scope.user.roles.push(USER_ROLES.ROLE_ADMIN)
                                } else if ($scope.user.roles.includes(USER_ROLES.ROLE_ADMIN) && !$scope.isAdmin) {
                                    $scope.user.roles = [USER_ROLES.ROLE_USER];
                                }
                                userService.saveSmallProfile($scope.user).then(() => {
                                    $mdDialog.hide();
                                    $mdToast.show(
                                        $mdToast.simple()
                                            .textContent('User has been saved.')
                                            .position('top center')
                                            .action('Hide')
                                            .highlightAction(true)
                                            .hideDelay(4000)
                                            .toastClass('success-toast'));
                                });
                            }
                        };
                        $scope.cancel = () => {
                            $mdDialog.cancel();
                        };
                    }
                }).then(() => {
                    self.onSuccess();
                });
            });
        };
    };
}

UserProfileController.$inject = ['UserService', '$mdDialog', '$mdToast'];

export default UserProfileController;



// WEBPACK FOOTER //
// ./src/app/pages/user/list/profile/userProfileController.js